import wretch from 'wretch';
import QueryStringAddon from 'wretch/addons/queryString';
import { parseJson } from './parseJson.js';

let polyfills;
let errorCatcherFn;
let logMiddleware;
let isNodeConfigured = false;
const setErrorCatcher = ({ errorCatcher, }) => {
    errorCatcherFn = errorCatcher;
};
const configureNodeFetch = ({ nodeFetch, logger, Headers, formData, }) => {
    if (typeof __webpack_require__ !== 'function') {
        isNodeConfigured = true;
        const { performance } = require('perf_hooks');
        const URLSearchParams = require('url').URLSearchParams;
        globalThis.Headers = Headers;
        const getRequestRuid = (headers) => {
            if (!Array.isArray(headers) && !(headers instanceof Headers)) {
                return headers === null || headers === void 0 ? void 0 : headers.ruid;
            }
        };
        polyfills = {
            fetch(url, opts) {
                const requestStart = performance.now();
                return nodeFetch(url, opts).then((res) => {
                    const requestEnd = performance.now();
                    logger({
                        url: decodeURIComponent(String(url)),
                        duration: requestEnd - requestStart,
                        ruid: getRequestRuid(opts === null || opts === void 0 ? void 0 : opts.headers),
                    }, 'API Request Duration');
                    return res;
                });
            },
            FormData: formData,
            URLSearchParams,
        };
        logMiddleware =
            () => (next) => (url, opts) => {
                return next(url, opts).then((res) => {
                    const headers = opts.headers;
                    if (headers) {
                        logger({
                            url: decodeURIComponent(res.url),
                            method: opts.method,
                            ruid: headers.ruid,
                            host: headers.host,
                            status: res.status,
                            statusText: res.statusText,
                        }, 'API Request');
                    }
                    return res;
                });
            };
    }
};
function request(path, options = {}) {
    const wretchInstance = wretch(path, options).addon(QueryStringAddon);
    if (typeof __webpack_require__ !== 'function') {
        if (!isNodeConfigured) {
            throw new Error('http has not been configured for node, did you forget configureNodeFetch()?');
        }
        return wretchInstance.polyfills(polyfills).middlewares([logMiddleware()]);
    }
    return wretchInstance.errorType('text');
}
function addErrorCatcher(responseChain) {
    if (!errorCatcherFn) {
        return responseChain;
    }
    [
        400, 401, 402, 403, 404, 405, 406, 408, 409, 422, 500, 501, 502, 503, 504,
    ].forEach((statusCode) => {
        responseChain.error(statusCode, errorCatcherFn);
    });
    responseChain.fetchError(errorCatcherFn);
    return responseChain;
}
function httpPost({ path, body, options }) {
    return addErrorCatcher(request(path, options).post(body));
}
function httpPatch({ path, body, options }) {
    return addErrorCatcher(request(path, options).patch(body));
}
function httpPut({ path, body, options }) {
    return addErrorCatcher(request(path, options).put(body));
}
function httpGet({ path, query = {}, options }) {
    return addErrorCatcher(request(path, options).query(query).get());
}
function httpDelete({ path, options, }) {
    return addErrorCatcher(request(path, options).delete());
}
function httpGetText({ path, query = {}, options, }) {
    return httpGet({ path, options, query }).text();
}
function httpGetJson({ path, query = {}, options, }) {
    return httpGetText({ path, query, options }).then((text) => parseJson(text));
}
function httpPostText({ path, body, options, }) {
    return httpPost({ path, body, options }).text();
}
function httpPostJson({ path, body, options, }) {
    return httpPostText({ path, body, options }).then((text) => parseJson(text));
}

export { configureNodeFetch, httpDelete, httpGet, httpGetJson, httpGetText, httpPatch, httpPost, httpPostJson, httpPostText, httpPut, setErrorCatcher };
//# sourceMappingURL=http.js.map
